module.exports = __webpack_public_path__ + "static/media/zumkha-result1.ecb5a8a3.png";